import React, { useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { enhanceTheme } from '../helpers/enhanceTheme';
export function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var enhancedTheme = useMemo(function () {
    return enhanceTheme(theme);
  }, [theme]);
  return React.createElement(StyledThemeProvider, {
    theme: enhancedTheme
  }, children);
}
ThemeProvider.childContextTypes = StyledThemeProvider.childContextTypes;